// File: cgp-snackbar.service.ts
// Author: Joseph M Diaz
// Date: 5/4/2017
// Desc: CGP Snackbar component.
// Other Contributors:

import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

const defaults = {
    message: '',
    action: '',
    type: 'accept',
    duration: 3000,
    onAction: null
};

@Injectable()
export class CgpSnackbarService {
    constructor(private readonly snackbar: MatSnackBar) { }

    showSnackbar(opts) {
        const options = {
            ...defaults,
            ...opts
        };
        const config: MatSnackBarConfig = {
            duration: options.duration,
        } as MatSnackBarConfig
        const snackbarRef = this.snackbar.open(options.message, options.action, config);

        snackbarRef.onAction().subscribe(() => {
            if (options.onAction) {
                options.onAction();
            }
        });

        return snackbarRef;
    }
}
